import { getCookie } from "./cookie-utils";
import envConfig from "../config";
import { isPlaceholderApiKeyExpiration } from "./api-key-expiry";
import { hasPendingUserVerification } from "./authx-login-helpers";

/**
 * Check if user is currently authenticated (AuthX: accessKey + refreshKey).
 * @returns {boolean} - true if user is authenticated, false otherwise
 */
export const isAuthenticated = () => {
  if (hasPendingUserVerification()) {
    return false;
  }

  const accessKey = getCookie("accessKey");
  const refreshKey = getCookie("refreshKey");
  if (
    !accessKey ||
    accessKey === "undefined" ||
    !refreshKey ||
    refreshKey === "undefined"
  ) {
    return false;
  }

  const expirationTime = getCookie("apiKeyExpirationUTCDate");
  if (isPlaceholderApiKeyExpiration(expirationTime)) {
    return true;
  }

  return validateSessionExpiration(expirationTime);
};

/**
 * Validate session expiration with enhanced timezone handling
 * @param {string} expirationTime - API key expiration time
 * @returns {boolean} - true if session is valid
 */
const validateSessionExpiration = (expirationTime) => {
  if (!expirationTime) {
    return true;
  }
  try {
    const currentTime = new Date();
    let expirationDate;

    if (expirationTime.endsWith("Z")) {
      expirationDate = new Date(expirationTime);
    } else {
      expirationDate = new Date(expirationTime + "Z");
    }

    const difference = expirationDate.getTime() - currentTime.getTime();

    const maxDiff = envConfig.loginUrl?.includes?.(".app") ? 1 : 5;
    const minValidTime = maxDiff * 60 * 1000;

    return difference > minValidTime;
  } catch (error) {
    console.error("🔐 Session Validation Error:", error, { expirationTime });
    return false;
  }
};

/**
 * Mark authentication as complete (clears verification flags)
 */
export const markAuthenticationComplete = () => {
  const { clearPendingVerificationState } = require("./authx-login-helpers");
  clearPendingVerificationState();
};

/**
 * Get the redirect URL for authenticated users
 * @returns {string} - the dashboard URL
 */
export const getAuthenticatedRedirectUrl = () => {
  return "/user-dashboard";
};
